/* eslint-disable no-unused-vars */
import { Menu } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./abouApplication.page.scss";

const items = [
	{
		key: "app",
		label: "About application",
	},
	{
		key: "terms",
		label: "Terms and conditions",
	},
	{
		key: "privacy",
		label: "Privacy policy",
	},
	{
		key: "agreement",
		label: "User agreement",
	},
	{
		key: "cancellation",
		label: "Cancellation policy",
	},
];

export const AboutApplicationPage = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [current, setCurrent] = useState("");
	const currentPage = location.pathname.split("/")[3];

	useEffect(() => {
		if (!currentPage) {
			onSelectItem({ key: "app" });
		}
		if (current !== currentPage) {
			setCurrent(currentPage);
		}
	}, [currentPage]);

	function onSelectItem(e) {
		setCurrent(e.key);
		navigate(e.key);
		const page = document.getElementById("about-app-content");
		page.scrollTo({ top: 0 });
	}

	return (
		<div className="about-app">
			<div className="mb-40">
				<Menu
					items={items}
					mode="horizontal"
					onClick={onSelectItem}
					selectedKeys={[current]}
					disabledOverflow={true}
					rootClassName="about-menu"
				/>
			</div>

			<div id="about-app-content" className="about-app__content">
				<Outlet />
			</div>
		</div>
	);
};
